var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmoduleWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_2119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2859 5.48877L11.799 9.42177V11.7138L22.2859 7.78078V5.48877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.487 13.4061L0 9.47314V11.7571L10.487 15.6901V13.4061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.799 15.6901L22.2859 11.7571V9.47314L11.799 13.4061V15.6901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.487 11.7128V9.42078L0 5.48877V7.78078L10.487 11.7128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.799 17.3939V19.8499L22.2859 15.9169V13.4609L11.799 17.3939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.487 17.3939L0 13.4609V15.9169L10.487 19.8499V17.3939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.143 7.866L21.63 3.933L11.143 0L0.652954 3.933L11.143 7.866Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_2119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.286,
    height: 19.85,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoduleWhite);
export default __webpack_public_path__ + "static/media/emoduleWhite.c3b6d44ae5e5202c8cc92406f7b8f9fd.svg";
export { ForwardRef as ReactComponent };